const isImage = (type: string): boolean => {
  return ["jpg", "jpeg", "png"].includes(type);
};

export { isImage };
